/**
 * Resolve wall-clock parts in an IANA timezone without extra date libraries.
 * Invalid timezones throw — callers validate at the API boundary.
 */
export function assertValidTimeZone(timeZone) {
    try {
        Intl.DateTimeFormat('en-US', { timeZone }).format(new Date());
    }
    catch {
        throw new Error(`Invalid IANA timezone: ${timeZone}`);
    }
}
export function getZonedClock(now, timeZone) {
    assertValidTimeZone(timeZone);
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone,
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    }).formatToParts(now);
    const weekday = parts.find((part) => part.type === 'weekday')?.value;
    const hour = parts.find((part) => part.type === 'hour')?.value;
    const minute = parts.find((part) => part.type === 'minute')?.value;
    if (!weekday || hour === undefined || minute === undefined) {
        throw new Error(`Failed to resolve local clock for timezone ${timeZone}`);
    }
    return {
        dayOfWeek: weekdayToNumber(weekday),
        minutesOfDay: Number(hour) * 60 + Number(minute),
    };
}
function weekdayToNumber(weekday) {
    switch (weekday) {
        case 'Sun':
            return 0;
        case 'Mon':
            return 1;
        case 'Tue':
            return 2;
        case 'Wed':
            return 3;
        case 'Thu':
            return 4;
        case 'Fri':
            return 5;
        case 'Sat':
            return 6;
        default:
            throw new Error(`Unexpected weekday token: ${weekday}`);
    }
}
//# sourceMappingURL=timezone.js.map